import axios from "axios";
import WriteToLog from "./WriteToLog";
import getObservationVitalsWeightWithin7Days from "./getObservationVitalsWeightWithin7Days";

/**
 * Get Observation.Search (Vitals) (R4) data from EHR
 * @param {*} patID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getObservationVitals(patFHIRID, fhir_server, access_token) {
  var category = "vital-signs";
  const vitals = {};

  var date = new Date();
  date.setHours(date.getHours() - 4);
  const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';

  var date2 = new Date();
  date2.setHours(date2.getHours() - 1);
  const isoStringWithoutMs2 = date2.toISOString().slice(0, 19) + 'Z';

  const ehrconfig = await axios.get('ehrconfig.json');
  let observationSearchUrl = ehrconfig.data["EHR_OBSERVATION_SEARCH_R4"];
  let getObservationVitalsUrl = fhir_server + observationSearchUrl + '?category=' + category + '&patient=' + patFHIRID + '&date=ge' + isoStringWithoutMs + '&date=le' + isoStringWithoutMs2;

  try {
    let response = await axios.get(
      getObservationVitalsUrl,
      {
        headers:
        {
          'Authorization': 'Bearer ' + access_token,
          'Accept': 'application/json'
        }
      });
    //WriteToLog("getObservationVitals Observation.Search (R4) FHIR response: " + JSON.stringify(response.data));
    if (response.data.total > 0) {
      let entryArray = response.data.entry;
      for (var i= 0; i < entryArray.length; i++) {
        if (entryArray[i].resource !== undefined) {
          let resourceType = entryArray[i].resource.resourceType;
          if (resourceType === "Observation" && entryArray[i].resource.code !== undefined) {
            let code = entryArray[i].resource.code.text;
            if (code === "Pulse" || code === "SpO2" || code === "Weight" || code === "Temp") {
              if (entryArray[i].resource.valueQuantity !== undefined) {
                const floValue = {};
                floValue.value = entryArray[i].resource.valueQuantity.value;
                floValue.unit = entryArray[i].resource.valueQuantity.unit;
                floValue.timestamp = entryArray[i].resource.issued;
                //console.log("floValue: " + JSON.stringify(floValue));
                // Get the latest value from the top
                if(vitals[code] === undefined ) {
                  vitals[code] = floValue;
                }
              }
            } else if (code === "BP") {
              if (entryArray[i].resource.component !== undefined) {
                for (var c=0; c<entryArray[i].resource.component.length; c++) {
                  let bpcode = entryArray[i].resource.component[c].code.text;
                  if (bpcode === "Systolic blood pressure" || bpcode === "Diastolic blood pressure") {
                    if (entryArray[i].resource.component[c].valueQuantity !== undefined) {
                      const floValue = {};
                      floValue.value = entryArray[i].resource.component[c].valueQuantity.value;
                      floValue.unit = entryArray[i].resource.component[c].valueQuantity.unit;
                      floValue.timestamp = entryArray[i].resource.issued;
                      //console.log("BP floValue: " + JSON.stringify(floValue));
                      // Get the latest value from the top
                      if(vitals[bpcode] === undefined ) {
                        vitals[bpcode] = floValue;
                      }
                    }
                  }
                }
              }
            } // end of if (code === "BP")
          }
        }
      }
      // If Weight is empty, get Weight value entered within the last 7 days
      if (vitals.Weight === null || vitals.Weight === undefined || vitals.Weight === "") {
        let weight = await getObservationVitalsWeightWithin7Days(patFHIRID, fhir_server, access_token);
        if (weight !== "Resource request returns no results." || !weight.includes("Error:")) {
          vitals.Weight = weight;
          return vitals;
        } else {
          return weight;
        }
      } 
      WriteToLog("getObservationVitals Observation.Search (R4) response: " + JSON.stringify(vitals));
      return vitals;
    } else {
      // Get Weight value entered within the last 7 days
      let weight = await getObservationVitalsWeightWithin7Days(patFHIRID, fhir_server, access_token);

      if (weight !== "Resource request returns no results." || !weight.includes("Error:")) {
        vitals.Weight = weight;
        return vitals;
      } else {
        return weight;
      }
    }
  } catch (error) {
    if (!error.message.includes("401")) { // 401 - Access Token Expired
      WriteToLog("getObservationVitals Observation.Search FHIR error: " + error.message);
    }
    return null;
  }
}

export default getObservationVitals;
